module.exports = __webpack_public_path__ + "img/headphones-gamer-pc.0973f5de.png";